export const ACCOUNT = '/account'
export const ACCOUNT_CREATE = '/account/create'
export const ACCOUNT_EDIT = '/account/:id/edit'
export const MEDIA_AGENCY = '/media-agency'
export const MEDIA_AGENCY_CREATE = '/media-agency/create'
export const MEDIA_AGENCY_EDIT = '/media-agency/:id/edit'
export const SSP = '/ssp'
export const SSP_CREATE = '/ssp/create'
export const SSP_EDIT = '/ssp/:id/edit'
export const ADVERTISER = '/advertiser'
export const ADVERTISER_CREATE = '/advertiser/create'
export const ADVERTISER_EDIT = '/advertiser/:id/edit'
export const CAMPAIGN = '/campaign'
export const CAMPAIGN_CREATE = '/campaign/create'
export const CAMPAIGN_EDIT = '/campaign/:id/edit'
export const AD_GROUP = '/ad-group'
export const AD_GROUP_CREATE = '/ad-group/create'
export const AD_GROUP_EDIT = '/ad-group/:id/edit'
export const CREATIVE = '/creative'
export const CREATIVE_CREATE = '/creative/create'
export const CREATIVE_EDIT = '/creative/:id/edit'
export const CREATIVE_BULK = '/creative/bulk'
export const AD_SIZE = '/ad-size'
export const AD_SIZE_CREATE = '/ad-size/create'
export const AD_SIZE_EDIT = '/ad-size/:id/edit'
export const FILTER_LIST = '/filter-list'
export const FILTER_LIST_CREATE = '/filter-list/create'
export const FILTER_LIST_EDIT = '/filter-list/:id/edit'
export const TEST_REQUEST = '/test-request'
export const REPORT = '/report'
export const LOG = '/log'
export const DASHBOARD = '/dashboard'


// WEBPACK FOOTER //
// ./src/constants/routes.ts